<template>
  <small class="app-small-text" :class="{ block }">
    <slot />
  </small>
</template>

<script>
export default {
  name: 'AppSmallText',

  props: {
    block: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.app-small-text {
  color: rgba(0, 0, 0, 0.54);

  &.block {
    display: block;
  }
}
</style>
